import { ampli } from 'lib-shared-tracking';

import { PartnerTrackingEventsProps } from '../partners.types';

export const jiraPartnerTrackingEvents = ({
  partnerEvents,
}: PartnerTrackingEventsProps): void => {
  partnerEvents.on('jira:view:jira:clicked', (payload) =>
    ampli.partnerIntegrationsJiraOpenJiraClicked(payload),
  );

  partnerEvents.on('jira:view:issue:clicked', (payload) =>
    ampli.partnerIntegrationsJiraOpenIssueClicked(payload),
  );

  partnerEvents.on('jira:issue:create:succeeded', (payload) =>
    ampli.partnerIntegrationsJiraCreateIssueSucceeded(payload),
  );

  partnerEvents.on('jira:issue:create:failed', (payload) =>
    ampli.partnerIntegrationsJiraCreateIssueFailed(payload),
  );

  partnerEvents.on('jira:issue:link:clicked', (payload) =>
    ampli.partnerIntegrationsJiraLinkIssueClicked(payload),
  );

  partnerEvents.on('jira:issue:comments:expand', (payload) =>
    ampli.partnerIntegrationsJiraCommentsExpanded(payload),
  );

  partnerEvents.on('jira:issue:comments:collapse', (payload) =>
    ampli.partnerIntegrationsJiraCommentsCollapsed(payload),
  );

  partnerEvents.on('jira:issue:unlink:clicked', (payload) =>
    ampli.partnerIntegrationsJiraUnlinkIssueClicked(payload),
  );

  partnerEvents.on('jira:issue:unlink:confirmed', (payload) =>
    ampli.partnerIntegrationsJiraUnlinkIssueConfirmed(payload),
  );

  partnerEvents.on('jira:issue:unlink:cancelled', (payload) =>
    ampli.partnerIntegrationsJiraUnlinkIssueCancelled(payload),
  );

  partnerEvents.on('jira:issue:unlink-all:clicked', (payload) =>
    ampli.partnerIntegrationsJiraUnlinkAllIssuesClicked(payload),
  );

  partnerEvents.on('jira:issue:unlink-all:confirmed', (payload) =>
    ampli.partnerIntegrationsJiraUnlinkAllIssuesConfirmed(payload),
  );

  partnerEvents.on('jira:issue:unlink-all:cancelled', (payload) =>
    ampli.partnerIntegrationsJiraUnlinkAllIssuesCancelled(payload),
  );

  partnerEvents.on('jira:issue:unlink-dangling:clicked', (payload) =>
    ampli.partnerIntegrationsJiraRemoveDanglingIssueClicked(payload),
  );

  partnerEvents.on('jira:issue:unlink-all-dangling:clicked', (payload) =>
    ampli.partnerIntegrationsJiraRemoveAllDanglingClicked(payload),
  );
};
